module.exports = __webpack_public_path__ + "media/intro_video.638c1cf0.mp4";